<!-- 层压顺序 -->
<template>
  <BaseFormItem2
    class="overlay_type"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <BaseRadioGroup2 v-model="val.overlay_type" :isError="isError" @change="handleTypeChange">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup2>
    <template v-if="val.overlay_type == 3">
      <i class="overlay_type__linker">-</i>
      <BaseInput2 
        ref="seqInputRef"
        v-model.trim="val.overlay_seq" 
        width="246px" 
        placeholder="例如：TOP-GND-POWER-BOTTOM"
        :isError="isError"
        @input="handleEmit('overlay_seq')"
        @change="handleEmitChange"
      ></BaseInput2>
    </template>
    <span v-if="val.overlay_type == 1" slot="other" class="overlay_type__tips">
      提交订单时可录入工程师联系方式
    </span>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    overlay_type: {
      type: Number,
      default: 2
    },
    overlay_seq: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      val: {
        overlay_type: this.overlay_type,
        overlay_seq: this.overlay_seq
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('overlay_type')
    }
  },
  watch: {
    type(overlay_type) {
      this.val.overlay_type = overlay_type
    },
    overlay_seq(overlay_seq) {
      this.val.overlay_seq = overlay_seq
    }
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleEmitChange() {
      this.$emit('change', { ...this.val })
    },
    handleTypeChange() {
      if (this.val.overlay_type != 3) {
        this.val.overlay_seq = ''
        this.handleEmit('overlay_seq')
      } else {
        this.$refs.seqInputRef.focus()
      }
      this.handleEmit('overlay_type')
      this.handleEmitChange()
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.overlay_type {
  .overlay_type__linker {
    margin: 0 4px;
    color: $--color-text-placeholder;
  }
  .overlay_type__tips {
    font-size: 12px;
    color: $--color-text-placeholder;
  }
}
</style>